import { StyledIconBase } from "@styled-icons/styled-icon";
import { Col, Row, Button } from "components/primitives";
import { FC, useState, useEffect } from "react";
import { Modal, Accordion } from "react-bootstrap";
import styled from "styled-components";

import { Event } from "./Event";
import { CalendarItemData } from "./interfaces";

interface Props {
  currentEvents?: CalendarItemData[];
  hasClosed?: () => void;
  deleteSelectedEvent: (id: string) => void;
  handleAddEvent: () => void;
  onEditSubmit: (newEvent: CalendarItemData) => void;
}

export const CurrentEventsModal: FC<Props> = ({
  currentEvents,
  hasClosed,
  deleteSelectedEvent,
  handleAddEvent,
  onEditSubmit,
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const onClose = () => {
    setIsClosing(true);
  };

  return (
    <Modal
      show={!isClosing}
      onHide={onClose}
      size="lg"
      onExited={hasClosed}
      centered
      className="no-drag"
    >
      <Modal.Header>
        <HeaderRow>Events</HeaderRow>
      </Modal.Header>
      <Modal.Body>
        <EventCol>
          {!currentEvents ? (
            <p>No assigned events, a maximum of 3 events can be added per day.</p>
          ) : (
            <Accordion>
              {currentEvents?.map((event) => {
                return (
                  <Event
                    deleteSelectedEvent={deleteSelectedEvent}
                    event={event}
                    key={event.id}
                    onSubmit={onEditSubmit}
                  />
                );
              })}
            </Accordion>
          )}
        </EventCol>
      </Modal.Body>
      <Modal.Footer>
        <FooterButton color="var(--gray)" onClick={onClose}>
          Close
        </FooterButton>
        <FooterButton
          color="var(--primary)"
          onClick={handleAddEvent}
          disabled={(currentEvents ?? []).length > 2}
        >
          Add an event
        </FooterButton>
      </Modal.Footer>
    </Modal>
  );
};

const HeaderRow = styled(Row)`
  color: var(--secondary);
  align-items: center;
  gap: 10px;
  height: 30px;
  font-size: 16pt;
  font-weight: 600;

  ${StyledIconBase} {
    height: 100%;
  }
`;

const EventCol = styled(Col)`
  gap: 16px;
  max-height: 90vh;
`;

const FooterButton = styled(Button)<{ color: string }>`
  background-color: ${(props) => props.color};
  box-shadow: none;
  color: black;
  width: 20%;
`;
